import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyCodePipe } from './currency-code.pipe';

@Pipe({
	name: 'smartyCurrency',
	standalone: true,
})
export class SmartyCurrencyPipe implements PipeTransform {
	protected readonly decimalPipe = inject(DecimalPipe);
	protected readonly currencyCodePipe = inject(CurrencyCodePipe);

	// Default number format
	private readonly DEFAULT_FORMAT = '0.2-2';

	transform(value: number, numberFormat?: string, currencyId?: string): string | null {
		if (value !== undefined && value !== null) {
			return (
				this.decimalPipe.transform(value, numberFormat ?? this.DEFAULT_FORMAT) +
				this.currencyCodePipe.transform(currencyId)
			);
		}
		return null;
	}
}
